import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type AssignmentLocationData = NonNullable<
  ResultOf<typeof assignmentLocationsQuery>["assignmentLocations"]
>[number];

export type AssignmentLocation = AssignmentLocationData["locations"][number];

export const assignmentLocationsQuery = graphql(`
  query AssignmentLocations($assignmentIds: [ID!]!) {
    assignmentLocations(assignmentIds: $assignmentIds) {
      assignmentId
      locations {
        id
        latitude
        longitude
        recorded_at
        created_at
      }
      latestLocation {
        id
        latitude
        longitude
        recorded_at
        created_at
      }
    }
  }
`);
